<template>
  <transition name="confirm-fade">
    <div v-if="visible" class="confirm-overlay" @click.self="handleCancel">
      <div class="confirm-dialog">
        <div class="confirm-content">
          <div class="confirm-message">{{ message }}</div>
        </div>
        <div class="confirm-actions">
          <button class="confirm-btn confirm-btn-cancel" @click="handleCancel">
            Cancel
          </button>
          <button class="confirm-btn confirm-btn-confirm" @click="handleConfirm">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Confirm',
  data() {
    return {
      visible: false,
      message: '',
      resolve: null
    }
  },
  methods: {
    show(message) {
      this.message = message
      this.visible = true
      
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    handleConfirm() {
      this.visible = false
      if (this.resolve) {
        this.resolve(true)
        this.resolve = null
      }
    },
    handleCancel() {
      this.visible = false
      if (this.resolve) {
        this.resolve(false)
        this.resolve = null
      }
    }
  }
}
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  backdrop-filter: blur(4px);
}

.confirm-dialog {
  background: white;
  border-radius: 12px;
  min-width: 300px;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.confirm-content {
  padding: 30px 24px 20px;
}

.confirm-message {
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  text-align: center;
  word-break: break-word;
}

.confirm-actions {
  display: flex;
  border-top: 1px solid #e5e5e5;
}

.confirm-btn {
  flex: 1;
  padding: 16px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.confirm-btn:active {
  opacity: 0.7;
}

.confirm-btn-cancel {
  color: #666;
  border-right: 1px solid #e5e5e5;
}

.confirm-btn-cancel:hover {
  background: #f5f5f5;
}

.confirm-btn-confirm {
  color: #ffc200;
  font-weight: 600;
}

.confirm-btn-confirm:hover {
  background: #fffbf0;
}

/* 动画 */
.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.3s ease;
}

.confirm-fade-enter-active .confirm-dialog,
.confirm-fade-leave-active .confirm-dialog {
  transition: transform 0.3s ease;
}

.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}

.confirm-fade-enter .confirm-dialog,
.confirm-fade-leave-to .confirm-dialog {
  transform: scale(0.9);
}

/* 移动端适配 */
@media (max-width: 767px) {
  .confirm-dialog {
    min-width: 280px;
  }

  .confirm-content {
    padding: 24px 20px 16px;
  }

  .confirm-message {
    font-size: 15px;
  }

  .confirm-btn {
    padding: 14px;
    font-size: 15px;
  }
}
</style>
